// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFeedbackByOrganisationIdRequestModel from '../../model/get-feedback-by-organisation-id-request-model';
import GetFeedbackByOrganisationIdRequestDTO from '../dto/get-feedback-by-organisation-id-request-dto';
import dtoSchema from '../schemas/get-feedback-by-organisation-id-request-schema';

export default abstract class GetFeedbackByOrganisationIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFeedbackByOrganisationIdRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.organisationId = data.organisationId;
      this.eventIdentifier = data.eventIdentifier;
      this.selectedOrganisationId = data.selectedOrganisationId;
      this.selectedEventId = data.selectedEventId;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  organisationId?: number;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedEventId?: number;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetFeedbackByOrganisationIdRequestDTO>): GetFeedbackByOrganisationIdRequestModel;
  static toModel(dto: DeepPartial<GetFeedbackByOrganisationIdRequestDTO> | undefined | null): GetFeedbackByOrganisationIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFeedbackByOrganisationIdRequestDTO> | undefined | null): GetFeedbackByOrganisationIdRequestModel | undefined {
    return dto ? new GetFeedbackByOrganisationIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFeedbackByOrganisationIdRequestModel> | GetFeedbackByOrganisationIdRequestModel): GetFeedbackByOrganisationIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      organisationId: unwrapped.organisationId,
      eventIdentifier: unwrapped.eventIdentifier,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedEventId: unwrapped.selectedEventId,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetFeedbackByOrganisationIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFeedbackByOrganisationIdRequestModel, can not map to GetFeedbackByOrganisationIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
